import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import FloatingChat from './components/FloatingChat'
import WhatsAppButton from './components/WhatsAppButton'
import CallButton from './components/CallButton'
import MailButton from './components/MailButton'
import Home from './pages/Home'
import Services from './pages/Services'
import Pricing from './pages/Pricing'
import About from './pages/About'
import Blog from './pages/Blog'
import BlogPost from './pages/BlogPost'
import Admin from './pages/Admin'
import WidgetAdminLogin from './pages/WidgetAdminLogin'
import WidgetClients from './pages/WidgetClients'
import WidgetClientForm from './pages/WidgetClientForm'
import WidgetLeads from './pages/WidgetLeads'
import WidgetAdminGuard from './components/WidgetAdminGuard'
import ClientPortal from './pages/ClientPortal'
import WidgetContextDocs from './pages/WidgetContextDocs'
import ItSolutions from './pages/ItSolutions'
import Contact from './pages/Contact'
import Login from './pages/Login'
import TermsOfService from './pages/TermsOfService'
import PrivacyPolicy from './pages/PrivacyPolicy'
import RefundPolicy from './pages/RefundPolicy'
import Disclaimer from './pages/Disclaimer'
import CookiePolicy from './pages/CookiePolicy'
import NotFound from './pages/NotFound'

export default function App() {
  const location = useLocation()
  const hideFloatingChat = location.pathname.startsWith('/client-portal')
  return (
    <>
      <ScrollToTop />
      {!hideFloatingChat && <FloatingChat />}
      {!hideFloatingChat && <WhatsAppButton />}
      {!hideFloatingChat && <CallButton />}
      {!hideFloatingChat && <MailButton />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/widget/login" element={<WidgetAdminLogin />} />
        <Route path="/admin/widget" element={<Navigate to="/admin/widget/clients" replace />} />
        <Route path="/admin/widget/clients" element={<WidgetAdminGuard><WidgetClients /></WidgetAdminGuard>} />
        <Route path="/admin/widget/clients/new" element={<WidgetAdminGuard><WidgetClientForm /></WidgetAdminGuard>} />
        <Route path="/admin/widget/clients/:id/edit" element={<WidgetAdminGuard><WidgetClientForm /></WidgetAdminGuard>} />
        <Route path="/admin/widget/clients/:id/leads" element={<WidgetAdminGuard><WidgetLeads /></WidgetAdminGuard>} />
        <Route path="/docs/widget-context" element={<WidgetContextDocs />} />
        <Route path="/client-portal/:clientId" element={<ClientPortal />} />
        <Route path="/it-solutions" element={<ItSolutions />} />
                 <Route path="/contact" element={<Contact />} />
         <Route path="/login" element={<Login />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/refund" element={<RefundPolicy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  )
}
